import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { signOut } from 'firebase/auth';
import { auth } from '@/lib/firebase';

interface User {
    id: string;
    email: string;
    full_name: string;
    avatar_url: string | null;
    plan?: 'free' | 'pro';
    auth_provider?: 'local' | 'google' | 'apple';
}

interface Workspace {
    id: string;
    name: string;
    slug: string;
}

interface AuthState {
    user: User | null;
    workspace: Workspace | null;
    token: string | null;
    isAuthenticated: boolean;

    // Actions
    login: (user: User, workspace: Workspace | null, token: string) => void;
    logout: () => void;
    setWorkspace: (workspace: Workspace) => void;
    updateUser: (user: Partial<User>) => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set, get) => ({
            user: null,
            workspace: null,
            token: null,
            isAuthenticated: false,

            login: (user, workspace, token) => {
                set({
                    user,
                    workspace,
                    token,
                    isAuthenticated: true,
                });
            },

            logout: () => {
                // Sign out from Firebase
                signOut(auth).catch(console.error);
                set({
                    user: null,
                    workspace: null,
                    token: null,
                    isAuthenticated: false,
                });
            },

            setWorkspace: (workspace) => {
                set({ workspace });
            },

            updateUser: (userData) => {
                const { user } = get();
                if (user) {
                    set({ user: { ...user, ...userData } });
                }
            },
        }),
        {
            name: 'visionboard-auth',
            partialize: (state) => ({
                user: state.user,
                workspace: state.workspace,
                token: state.token,
                isAuthenticated: state.isAuthenticated,
            }),
        }
    )
);
